<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loading">
                    <p>Order Type: {{orderType}}</p>
                    <p>Order Status: {{orderStatus}}</p>
                    <div class="mb-3" v-if="showMessageBox">
                        <div class="form-group">
                            <label for="reasonInput">
                                Message
                            </label>
                            <div class="text-danger">
                                {{newEnquiryMessage.message.errorMessage}}
                            </div>
                            <textarea class="form-control" id="reasonInput" v-model="newEnquiryMessage.message.value" rows="4" cols="50"></textarea>
                            <button class="btn btn-primary mt-2" @click="sendEnquiryMessage">Send Message</button>
                        </div>
                    </div>
                    <div v-for="orderEnquiryMessage in orderEnquiryMessages" 
                         :class="{'messagingLeftMargin': orderEnquiryMessage.isUser, 'messagingRightMargin': !orderEnquiryMessage.isUser}">
                        <div class="card border border-secondary mb-3" >
                            <div class="card-body text-secondary">
                                <p v-if="orderEnquiryMessage.isUser">Message From: {{orderEnquiryMessage.user}} (You)</p>
                                <p v-if="orderEnquiryMessage.isPetroNetworkUser">Message From: {{orderEnquiryMessage.user}} (PetroNetwork)</p>
                                <p v-if="orderEnquiryMessage.isCustomerUser">Message From: {{orderEnquiryMessage.user}} ({{company.registeredCompanyName}})</p>
                                <p>Message Date: {{orderEnquiryMessage.insertedOn}}</p>
                                <p>{{orderEnquiryMessage.enquiryMessage}}</p>
                                <br>
                                <br>
                                <button class="btn btn-primary float-right" @click="openReplyBox">Reply</button>
                            </div>
                        </div>
                    </div>
                    

                    <div class="row mt-3" id="paginationControls" v-if="orderEnquiryMessages !== null && orderEnquiryMessages.length > 0">
                        <div class="col-4 text-left">
                            <button id="previousButton" class="btn btn-primary waves-effect waves-light"
                                    :disabled="pagingDetails.pageNumber === 1"
                                    @click="previousPage">
                                <i class="fa fa-arrow-left"></i> Previous
                            </button>
                        </div>
                        <div class="col-4 text-center paginationPageNumbering">
                            <span>
                                <input type="number" class="pageNumber-textbox" v-model="pagingDetails.pageNumber" @input="onPageNumberInput" @blur="onPageNumberBlur"/>
                            </span>
                                    /
                            <span id="totalPages">{{pagingDetails.totalPages}}</span>
                        </div>
                        <div class="col-4 text-right">
                            <button id="nextButton" class="btn btn-primary waves-effect waves-light"
                                    :disabled="pagingDetails.pageNumber === pagingDetails.totalPages"
                                    @click="nextPage">
                                Next <i class="fa fa-arrow-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>

            </div>
        </div>
    </div>

    <success-modal
            :modalHeading="successModal.modalHeading"
            :elementId="'reviewOrderSuccessModal'"
            :modalMessage="successModal.modalMessage"
            :showModal="successModal.showModal"
            @okClicked="onSuccessModalOkClick">

    </success-modal>
</div>
